import React from "react";
import { useLoading } from "./LoadingContext";
import "./LoadingOverlay.css";

const LoadingOverlay = () => {
  const { loading, message } = useLoading();

  if (!loading) return null;

  return (
    <div className="loading-overlay">
      <img
        src="/assets/robot-loader.webp"
        alt="AI robot studying"
        className="cinematic-robot-bg"
      />

      <div className="cinematic-noise"></div>
      <div className="cinematic-scan"></div>

      <div className="cinematic-loader-content">
        <div className="cinematic-brand-pill">STUDYAIPLACEMENT SYSTEM</div>

        <h1 className="cinematic-title">
          AI is studying your request
        </h1>

        <p className="cinematic-message">
          {message || "AI is analyzing your request securely..."}
        </p>

        <div className="cinematic-console">
          <div className="cinematic-console-line line-a">
            <b>&gt;</b> Reading secure request
          </div>
          <div className="cinematic-console-line line-b">
            <b>&gt;</b> Validating student information
          </div>
          <div className="cinematic-console-line line-c">
            <b>&gt;</b> Preparing protected response
          </div>
        </div>

        <div className="cinematic-progress">
          <span></span>
        </div>
      </div>
    </div>
  );
};



export default LoadingOverlay;